<template>
  <component :is="content_type" v-bind="$props" v-model="val"></component>
</template>

<script>
import Internal from './ContentSelect/Internal'
import * as Externals from './ContentSelect/externals.js'
import {EventMixin} from '@/lib/mixins.js';

export default {
  mixins: [EventMixin],
  props: [
    'value',
    'label',
    'name',
    'content_type',
    'content_id',
    'content_id_get_fun',
    'from',
    'from_key',
    'from_get_fun',
    'item-text',
    'item-value',
    'clearable',
    'required',
    'autoselect_first',
    'multiple',
    'settings'
  ],
  components: {
    Internal,
    ...Externals
  },
  computed: {
    val: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit("input", val);
      }
    }
  }
}
</script>
